import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { useDebounce } from '@aibees/shared/hooks';
import { useDeferredValue, useMemo, useState } from 'react';
import { useBrowseCompanyEmployees } from './use-browse-company-employees';

export function useEmployeesData() {
  const companyId = useSearchFiltersStore((state) => state.selectedItemId);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm.trim(), 250);
  const deferredSearchTerm = useDeferredValue(debouncedSearchTerm);

  const { data, isLoading } = useBrowseCompanyEmployees(
    {
      page: 0,
      size: 10,
      data: {
        company_id: companyId,
        ...(deferredSearchTerm ? { fullName: deferredSearchTerm } : {}),
      },
    },
    {
      enabled: !!companyId,
    }
  );

  const filteredData = useMemo(() => data?.content, [data?.content]);
  const emptyData = filteredData?.length === 0;

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  return { filteredData, emptyData, isLoading, handleSearch };
}
